export default "__VITE_ASSET__13cfab63__"